import { DesignClass, ObjectClass } from "@app/types";
// This import cannot be shortened without creating circular dependencies.
import { createUuid } from "../functions/string";

/**
 * JSDoc imports.
 *
 * @import {
 *   Design,
 * } from '@app/types';
 */

export default class ModuleUsedIn {
    
    /**
     * getModuleUsedIn
     * @param {Object} mod module to search for
     * @param {Design} serialized
     * @param {Object} config used to add various paraemters, such as excludeDisabledInFlow
     */
    static getModuleUsedIn(mod, serialized, config){
        const {components, globalIntents, globalErrorHandling, globalExceptionHandling, omniChannel} = serialized;
        var modUsedIn = {
            usedInFlows: ModuleUsedIn.getModuleUsedInModuleFlows(mod, components, config)[0],
            usedInModuleInputs: ModuleUsedIn.getModuleUsedInModuleFlows(mod, components)[1],
            usedInObjects: serialized.components.objects.filter((object) => {
                switch (object._class) {
                    case ObjectClass.withFiller:
                        return object.props.config.referenceId === mod.id;
                }
                return false;
            }).map((object) => {
                return object.id;
            }),
            usedInLocalVariables:ModuleUsedIn.getModuleUsedInModuleFlows(mod, components)[2],
            usedInExitNodes: ModuleUsedIn.getModuleUsedInExitNodes(mod, components),
            usedInGlobalIntents: (globalIntents) ? ModuleUsedIn.getModuleUsedInGlobalIntents(mod, globalIntents) : [],
            usedInGlobalErrorHandlig: (globalErrorHandling) ? ModuleUsedIn.getModuleUsedInGlobalErrorHandling(mod, globalErrorHandling) : [],
            usedInGlobalExceptionHandlig: (globalExceptionHandling) ? ModuleUsedIn.getModuleUsedInGlobalExceptionHandling(mod, globalExceptionHandling) : []
        };

        return modUsedIn;
    }
    
    static getModuleUsedInModuleFlows(mod, components, config){
        const usedInFlows = [];
        const usedInModuleInputs = [];
        const usedInLocalVariables = [];
        const excludeDisabledInFlow = config && config.excludeDisabledInFlow || false;

        components.modules.forEach(cm => {
            const nodes = cm.versions[1].flow.nodes.filter(node => node._class === DesignClass.module);
            if(mod.name!==""){
                if (cm.props.config.inputs && cm.props.config.inputs.length > 0) {
                    if (cm.props.config.inputs.findIndex(input => input.value === mod.name) !== -1) {
                        usedInFlows.push(cm.id);
                    }
                }
                const localVariables  = cm.localVariables || [];
                localVariables.forEach(lv => {
                    if (lv.props.config.type&&lv.props.config.type==="MODULE"&&lv.props.config.defaultValue === mod.name) {
                        usedInLocalVariables.push({ cm, lv,type:"usedInLocalVariables" });
                    }
                });
              
                
            }
            
            nodes.forEach(node => {
                const useId = (mod.props.moduleId && !mod.props.isCommonModule) ? mod.props.ref : mod.id;
                if(node.props.parentComponentID === useId){
                    // DEVDES2-1023 Do not return if containing module is disabled or if node is disabled
                    if(excludeDisabledInFlow){    
                        if(!cm.props.config.disabledInFlow){
                            if(!node.props.config.disabledInFlow){
                                usedInFlows.push(cm.id);
                            }
                        }
                        
                    }
                    else {
                        usedInFlows.push(cm.id);
                    }
                } 

                if (node.props.config && node.props.config.input&&mod.name!=="") {
                    node.props.config.inputs.forEach(input => {
                    if (input.type === "value") {
                        const moduleIndex = components.modules.findIndex(mo => mo.id === node.props.parentComponentID);
                        if(moduleIndex !== -1){ // TODO: Transfer module in GH_QUESTION in 800Flowers has a module with bad parentComponentID
                            const localVar = components.modules[moduleIndex].localVariables;
                            localVar.forEach(lv => {
                                var localVarIndex = input.argumentName.indexOf("mod." + lv.name);
                                if (localVarIndex !== -1&&lv.props.config.type==="MODULE") {
                                    if (input.value === mod.name) {
                                        usedInModuleInputs.push({
                                            cm,
                                            node,
                                            type: 'usedInModuleInputs'
                                        });
                                    }
                                }
                            });
                        }
                    }
                    });
                }
                
            });
        });
       
        return [usedInFlows,usedInModuleInputs,usedInLocalVariables];
    }

    static getModuleUsedInExitNodes(mod, components){
        const exitNodes = components.objects.filter(obj => obj._class === ObjectClass.exit);
        const usedInExitNodes = [];

        exitNodes.filter(node => JSON.stringify(node.props.config).includes(mod.id))
                .forEach(exitNode => {
                    usedInExitNodes.push({
                        exitNode
                    });
                });

        return usedInExitNodes;
    }

    static getModuleUsedInGlobalIntents(mod, globalIntents){
        
        const usedInGlobalIntents = [];
        
        globalIntents.forEach(gi => {
            if(gi.module === mod.id){
                usedInGlobalIntents.push(gi);
            }
            if (mod.name!==""&&gi.module && gi.moduleProperties.props.config.inputs && gi.moduleProperties.props.config.inputs.length > 0) {
                if (gi.moduleProperties.props.config.inputs.findIndex(input => input.value === mod.name) !== -1) {
                    usedInGlobalIntents.push(gi);
                }
            }
        });

        return usedInGlobalIntents;
    }

    static getModuleUsedInGlobalErrorHandling(mod, globalErrorHandling){
        const usedInGlobalErrorHandling = [];
        
        if (mod.id === globalErrorHandling.errorHandling) {
            usedInGlobalErrorHandling.push({
                name: "Global Intent Pre Processing Module",
                id: createUuid(),
                type: "inSettings"
            });
        }
        if (mod.id === globalErrorHandling.userHangUp) {
            usedInGlobalErrorHandling.push({
                name: "User Ended Session Module",
                id: createUuid(),
                type: "inSettings"
            });
        }
        if (mod.id === globalErrorHandling.returningFromWaitModule) {
            usedInGlobalErrorHandling.push({
                name: "Returning From Wait Module",
                id: createUuid(),
                type: "inSettings"
            });
        }
        if (mod.id === globalErrorHandling.sessionStart) {
            usedInGlobalErrorHandling.push({
                name: "Session Start Module",
                id: createUuid(),
                type: "inSettings"
            });

        }

        return usedInGlobalErrorHandling;
    }

    static getModuleUsedInGlobalExceptionHandling(mod, globalExceptionHandling){
        const usedInGlobalExceptionHandling = [];

        if (mod.id === globalExceptionHandling.exception) {
            usedInGlobalExceptionHandling.push({
                name: "Process Engine Exception or Error",
                id: createUuid(),
                type: "inSettings"
            });
        }
        if (mod.id === globalExceptionHandling.timeout) {
            usedInGlobalExceptionHandling.push({
                name: "Timeout Handler",
                id: createUuid(),
                type: "inSettings"
            });

        }

        return usedInGlobalExceptionHandling;
    }
}